<template>
  <div id="quick-task-loading" class="ma-card relative">
    <p
      class="ma-text-secondary text-right -mb-12 p-2 bg-primary w-max ml-auto rounded-full @md:rounded-bl-none text-sm @md:text-base absolute top-4 right-4 text-surface-0 opacity-0 animate-[fade-in-up_0.3s_0.6s_forwards]"
    >
      {{ $t("workingOnContent") }}
    </p>

    <div
      class="h-4 w-4 rounded-full bg-primary absolute top-14 left-2/3 @md:left-1/2 translate-x-4 opacity-0 animate-[fade-in-up_0.4s_0.3s_forwards]"
    ></div>
    <div
      class="h-2 w-2 rounded-full bg-primary absolute top-18 left-2/3 @md:left-1/2 opacity-0 animate-[fade-in-up_0.4s_forwards]"
    ></div>
    <DotLottieVue
      class="h-full w-full max-w-96 max-h-96 mt-8"
      autoplay
      loop
      src="/animations/cat-generate-content.lottie"
    />

    <p class="text-center ma-text-secondary pt-6">{{ $t("loading.wait") }}...</p>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
</script>
